import React from "react";
import "./EventsPage.css"; // Make sure to create this CSS file

const EventsPage = () => {
  return (
    <div className="events-container">
      <div className="scroll-wrapper">
        <img src="/images/Location Gradola Beach Club (10).png" alt="Events Schedule" className="scrollable-image" />
      </div>
    </div>
  );
};

export default EventsPage;